import {SpyneAppProperties, ViewStream} from 'spyne';
import { StageViewAuthLinkTraits } from 'traits/stage-view-auth-link-traits';
import { PricingTraits } from 'traits/pricing-traits';
import {LocalStorageTraits} from 'traits/local-storage-traits';

export class StageViewAuthLinks extends ViewStream {
  static #accessToken = null;

  constructor(props={}) {
        props.channels = ["CHANNEL_AUTH", "CHANNEL_MODAL_WINDOW"];
        props.traits = [StageViewAuthLinkTraits, PricingTraits];
        StageViewAuthLinks.#accessToken = props.token;
       //console.log("props in SVAL ", props);
        super(props);
    }

    addActionListeners() {
        // return nexted array(s)
        return [
          ["CHANNEL_MODAL_WINDOW_TOS_APPROVED_EVENT", "onTOSApproved"],
          ["CHANNEL_AUTH_PRICING_EVENT", "stageAuth$OnPricingEvent"],
          ["CHANNEL_AUTH_MANAGE_SETTINGS_EVENT", "stageAuth$OnManageSettingsEvent"],
          ["CHANNEL_AUTH_CALENDLY_EVENT", "stageAuth$OnCalendleyEvent"]
        ];
    }

    async onTOSApproved(e){

      const onUpdate = async()=> {
        let {auth0, user} = this.props;
        user = user || await auth0.getUser();
        user = user || LocalStorageTraits.localStorage$GetUser();

        const {sub} = user;

        const idToken = StageViewAuthLinks.#accessToken;

        if (idToken === null && auth0){
          auth0.loginWithRedirect();
        }

        this.stageAuth$AcceptTermsAndContinue(idToken, user)

        //console.log("AUTH AND USER IN STAGE LINKS5 ", this.props, {sub, user, auth0})

        //console.log("TYPE OF ID TOKEN ",  StageViewAuthLinks.#accessToken);
      }

      await onUpdate();
    }

    setTempToken(){
      SpyneAppProperties.setProp('stageToken', StageViewAuthLinks.#accessToken, true);
    }

    onPricingEvent(e){
     //console.log('pricing event ',StageViewAuthLinks.#accessToken)

    }



    broadcastEvents() {
        // return nexted array(s)
        return [];
    }
    sendTOSMsgRequest(){
      const channel = "CHANNEL_MODAL_WINDOW"
      const action = "CHANNEL_MODAL_WINDOW_LAUNCH_TOS_REQUEST_EVENT";
      this.sendInfoToChannel(channel, {action}, action);
    }

    onRendered() {

      const user = LocalStorageTraits.localStorage$GetUser();
      const role = user?.role;
      const tosAccepted = user?.tosAccepted;

     //console.log("STAGE VIEW LINKS USER ",{role, user}, this.props);


      const intent = localStorage.getItem("postAuthIntent");

      if (tosAccepted === false && user){
          this.sendTOSMsgRequest();

      } else if (intent === "upgrade_pro" && this.props.isAuthenticated === true) {

         if (role==='premium'){
           this.stageAuth$SendMessageRequestEvent(role);
         } else {
           this.stageAuth$OnPricingEvent();
         }


      } else if (intent === "userSettings"){

        this.stageAuth$OnManageSettingsEvent();

        localStorage.removeItem("postAuthIntent");


      }


    }

}

